import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Checkbox from '@repo/ui/checkbox'
import InnerBox from '@repo/ui/inner-box'
import Loader from '@repo/ui/loader'
import Typography from '@repo/ui/typography'
import { useQuery } from '@tanstack/react-query'
import { useFormContext } from 'react-hook-form'

import { getEnrollmentCharacteristics } from '../../../../api/enrollment-characteristics/get-enrollment-characteristics'
import { EnrollmentChildInput } from '../../../../lib/types/models/enrollment/enrollment-child-input'
import { getCharacteristicName } from '../../enrollment-characteristics/utils'

const ClientEnrollmentChildCharacteristics = () => {
  const form = useFormContext<EnrollmentChildInput>()

  const { data: characteristics } = useQuery({
    queryKey: ['enrollment-characteristics'],
    queryFn: getEnrollmentCharacteristics
  })

  if (!characteristics) return <Loader center />

  return (
    <InnerBox className="rounded-lg p-4 flex flex-col gap-4 ">
      <Typography variant="text" color={tailwindColors.grey.DEFAULT}>
        Caractère
      </Typography>
      <div className="grid grid-cols-2 gap-3">
        {characteristics.data.length === 0 ? (
          <Typography variant="label-medium" color={tailwindColors.grey.light.active}>
            Aucune caractéristique disponible
          </Typography>
        ) : (
          characteristics.data?.map((characteristic) => (
            <Checkbox
              key={characteristic.id}
              label={getCharacteristicName(characteristic)}
              checked={form.watch('characteristics')?.includes(characteristic.id)}
              onChange={(value) => {
                const currentCharacteristics = form.getValues('characteristics') || []
                if (value) {
                  // Add characteristic if checked
                  form.setValue('characteristics', [...currentCharacteristics, characteristic.id])
                } else {
                  // Remove characteristic if unchecked
                  form.setValue(
                    'characteristics',
                    currentCharacteristics.filter((id) => id !== characteristic.id)
                  )
                }
              }}
            />
          ))
        )}
      </div>
    </InnerBox>
  )
}

export default ClientEnrollmentChildCharacteristics
